import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import assert from "assert";
import { Box } from "../Box/Box.mjs";
import { Text } from "../Text/Text.mjs";
import { TextLinkButton } from "../TextLinkButton/TextLinkButton.mjs";
import { useDisclosure } from "./useDisclosure.mjs";
import { AvoidWidowIcon } from "../private/AvoidWidowIcon/AvoidWidowIcon.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { TextContext } from "../Text/TextContext.mjs";
import { HeadingContext } from "../Heading/HeadingContext.mjs";
import { IconChevron } from "../icons/IconChevron/IconChevron.mjs";
const Disclosure = ({
  id,
  expandLabel,
  collapseLabel = expandLabel,
  space = "medium",
  children,
  data,
  weight,
  ...restProps
}) => {
  assert(
    typeof expandLabel === "undefined" || typeof expandLabel === "string",
    "'expandLabel' must be a string"
  );
  assert(
    typeof collapseLabel === "undefined" || typeof collapseLabel === "string",
    "'collapseLabel' must be a string"
  );
  const textContext = useContext(TextContext);
  const headingContext = useContext(HeadingContext);
  const isInline = Boolean(textContext || headingContext);
  const { expanded, buttonProps, contentProps } = useDisclosure({
    id,
    ...restProps.expanded !== void 0 ? {
      onToggle: restProps.onToggle,
      expanded: restProps.expanded
    } : {
      onToggle: restProps.onToggle
    }
  });
  const trigger = /* @__PURE__ */ jsxs(TextLinkButton, { hitArea: "large", weight, ...buttonProps, children: [
    expanded ? collapseLabel : expandLabel,
    /* @__PURE__ */ jsx(AvoidWidowIcon, { iconPosition: "trailing", children: /* @__PURE__ */ jsx(IconChevron, { direction: expanded ? "up" : "down", alignY: "lowercase" }) })
  ] });
  const component = isInline ? "span" : "div";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      component,
      display: isInline ? "inline" : void 0,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            component,
            display: isInline ? "inline" : void 0,
            userSelect: "none",
            children: isInline ? /* @__PURE__ */ jsxs(Fragment, { children: [
              " ",
              trigger
            ] }) : /* @__PURE__ */ jsx(Text, { children: trigger })
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            component,
            paddingTop: space,
            display: expanded ? "block" : "none",
            ...contentProps,
            children
          }
        )
      ]
    }
  );
};
export {
  Disclosure
};
